// Utilities
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

// Translations
import da from './da.json'

const resources = {
  da
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "da",

    keySeparator: '.',

    interpolation: {
      escapeValue: false
    }
  })

export default i18n